import React from 'react';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Checkbox from '@material-ui/core/Checkbox';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import PropTypes from 'prop-types';
import styles from '../../../../styles/loadboard.module.scss';
import { useLocation } from 'react-router-dom';

const loadsHeadCells = [
  // {
  //   id: 'source',
  //   numeric: false,
  //   disablePadding: false,
  //   label: 'Source',
  // },
  { id: 'origin.name', numeric: false, disablePadding: false, label: 'Origin' },
  // {
  //   id: 'distance_origin',
  //   numeric: false,
  //   disablePadding: false,
  //   label: 'DH-O',
  // },
  {
    id: 'destination.name',
    numeric: false,
    disablePadding: false,
    label: 'Destination',
  },
  // {
  //   id: 'distance_destination',
  //   numeric: false,
  //   disablePadding: false,
  //   label: 'DH-D',
  // },
  // { id: 'trip_distance', numeric: false, disablePadding: false, label: 'Trip' },
  { id: 'pick_up_date', numeric: false, disablePadding: false, label: 'Pick Up' },
  { id: 'age', numeric: false, disablePadding: false, label: 'Age' },
  // { id: 'rpm', numeric: false, disablePadding: false, label: 'RPM' },
  {
    id: 'trailer_type',
    numeric: false,
    disablePadding: false,
    label: 'Equipment',
  },
  { id: 'rate', numeric: false, disablePadding: false, label: 'Rate' },
  {
    id: 'company_phone',
    numeric: false,
    disablePadding: false,
    label: 'Broker Phone',
  },
  // { id: 'full_partial', numeric: false, disablePadding: false, label: 'F/P' },
];

const userInterestHeadCells = [
  { id: 'interest_time', numeric: false, disablePadding: false, label: 'Interest Age' },
  { id: 'origin.name', numeric: false, disablePadding: false, label: 'Origin' },
  {
    id: 'destination.name',
    numeric: false,
    disablePadding: false,
    label: 'Destination',
  },
  { id: 'pick_up_date', numeric: false, disablePadding: false, label: 'Pick Up' },
  { id: 'age', numeric: false, disablePadding: false, label: 'Load Age' },
  {
    id: 'equipments_length_weight',
    numeric: false,
    disablePadding: false,
    label: 'Equipments',
  },
  // {
  //   id: 'last_contacted_by',
  //   numeric: false,
  //   disablePadding: false,
  //   label: 'Last contacted by',
  // },
  {
    id: 'interest_sent_by',
    numeric: false,
    disablePadding: false,
    label: 'Interests sent by',
  },
  { id: 'rate', numeric: false, disablePadding: false, label: 'Rate' },
  {
    id: 'company_phone',
    numeric: false,
    disablePadding: false,
    label: 'Broker Phone',
  },
];

const workbookRequestsHeadCells = [
  { id: 'interest_time', numeric: false, disablePadding: false, label: 'Interest Age' },
  { id: 'origin.name', numeric: false, disablePadding: false, label: 'Origin' },
  {
    id: 'destination.name',
    numeric: false,
    disablePadding: false,
    label: 'Destination',
  },
  { id: 'pick_up_date', numeric: false, disablePadding: false, label: 'Pick Up' },
  { id: 'age', numeric: false, disablePadding: false, label: 'Load Age' },
  // {
  //   id: 'last_contacted_by',
  //   numeric: false,
  //   disablePadding: false,
  //   label: 'Last contacted by',
  // },
  {
    id: 'interest_sent_by',
    numeric: false,
    disablePadding: false,
    label: 'Interests sent by',
  },
  { id: 'rate', numeric: false, disablePadding: false, label: 'Rate' },
  {
    id: 'company_phone',
    numeric: false,
    disablePadding: false,
    label: 'Broker Phone',
  },
];

const workbookBookingsHeadCells = [
  { id: 'origin.status', numeric: false, disablePadding: false, label: 'Status' },
  {
    id: 'origin.unique_load_id',
    numeric: false,
    disablePadding: false,
    label: 'Load Number',
  },
  {
    id: 'origin.oo',
    numeric: false,
    disablePadding: false,
    label: 'Owner Operator',
  },
  { id: 'origin.driver', numeric: false, disablePadding: false, label: 'Driver' },
  { id: 'origin.name', numeric: false, disablePadding: false, label: 'Origin' },
  {
    id: 'destination.name',
    numeric: false,
    disablePadding: false,
    label: 'Destination',
  },
  // { id: 'trip_distance', numeric: false, disablePadding: false, label: 'Trip' },
  { id: 'pick_up_date', numeric: false, disablePadding: false, label: 'Pick Up' },
  // { id: 'age', numeric: false, disablePadding: false, label: 'Age' },
  {
    id: 'trailer_type',
    numeric: false,
    disablePadding: false,
    label: 'Equipment',
  },
  { id: 'rate', numeric: false, disablePadding: false, label: 'Rate' },
  // {
  //   id: 'assigned_name',
  //   numeric: false,
  //   disablePadding: false,
  //   label: 'Assignee Name',
  // },
  // {
  //   id: 'assignee_phone',
  //   numeric: false,
  //   disablePadding: false,
  //   label: 'Assignee Phone',
  // },
];

const savedSearchHeadCells = [
  { id: 'type', numeric: false, disablePadding: false, label: 'Type' },
  { id: 'origin.name', numeric: false, disablePadding: false, label: 'Origin' },
  {
    id: 'distance_origin',
    numeric: false,
    disablePadding: false,
    label: 'DH-O',
  },
  {
    id: 'destination.name',
    numeric: false,
    disablePadding: false,
    label: 'Destination',
  },
  {
    id: 'distance_destination',
    numeric: false,
    disablePadding: false,
    label: 'DH-D',
  },
  {
    id: 'start_date',
    numeric: false,
    disablePadding: false,
    label: 'Start Date',
  },
  { id: 'end_date', numeric: false, disablePadding: false, label: 'End Date' },
  { id: 'length', numeric: false, disablePadding: false, label: 'Length' },
  { id: 'weight', numeric: false, disablePadding: false, label: 'Weight' },
  {
    id: 'trailer_type',
    numeric: false,
    disablePadding: false,
    label: 'Equipment',
  },
];

function LoadTableHead({ classes, order, orderBy, onRequestSort, customHeadCells, currentTab, permissions, active, status }) {
  const location = useLocation();
  let headCells =
    customHeadCells ||
    (currentTab === 1
      ? savedSearchHeadCells
      : location.pathname == '/loads/user-interests'
      ? userInterestHeadCells
      : location.pathname == '/workbook/requests'
      ? workbookRequestsHeadCells
      : location.pathname == '/workbook/bookings'
      ? workbookBookingsHeadCells
      : loadsHeadCells);
  const onSortOrderChange = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow className={styles.dailyLoadsTableHeader}>
        {headCells.map(headCell => (
          headCell && headCell.id ? 
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}>
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={onSortOrderChange(headCell.id)}>
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>{order === 'desc' ? 'sorted descending' : 'sorted ascending'}</span>
              ) : null}
            </TableSortLabel>
          </TableCell>
          : null
        ))}
        {(permissions.all && location.pathname != '/workbook/bookings' && active != 'Confirmed' && active != 'Rejected' && active != 'Failed' && status?.value != "Confirmed") || (permissions &&
          (permissions.loads &&
            (permissions.loads.loadboard &&
            permissions.loads.loadboard.actions.includes('BookBid')) ||  
            (permissions?.loads?.user_interests &&
            permissions?.loads?.user_interests?.actions.includes('BookBid'))) || 
            (permissions.workbook && permissions.workbook.requests && permissions.workbook.requests.actions.includes("MarkConfirmedRejected")))
         ? (
          <TableCell align="left">Actions</TableCell>
        ) : null}
        {/* {currentTab === 2 ? <TableCell>More</TableCell> : null} */}
        {/* <TableCell>More</TableCell> */}
      </TableRow>
    </TableHead>
  );
}

LoadTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  // numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  // onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  // rowCount: PropTypes.number.isRequired,
};

export default React.memo(LoadTableHead);
